/* src/app/components/payroll/purchase-request/purchase-request-staff-view/purchase-request-staff-view.component.css */
::ng-deep .limit-dialog-width .xx-large {
  max-width: 75%;
}
/*# sourceMappingURL=purchase-request-staff-view.component-VXNZDAWC.css.map */
